import { PureComponent } from 'react';
import { UAParser } from 'ua-parser-js'

// export function BrowserDetails() {
export class BrowserDetails extends PureComponent {
    // console.log(p.getResult());
    // console.log(p.getBrowser());

    createUlLiOffObject(obj) {

        Object.entries(obj).map(([key, value]) => (
            <li key={key}>{key}: {value}</li>
        )
        )
        return "HA!";    

    }

    render() {
        const p = new UAParser();
        return (
            <>
                <h2>Technische Details</h2>
                <h3>Browser</h3>
                <ul>
                    {
                        // this.createUlLiOffObject(p.getBrowser())
                        Object.entries(p.getBrowser()).map(([key, value]) => (
                            <li key={key}>{key}: {value}</li>
                        ))
                    }
                </ul>

                <h3>CPU</h3>
                <ul>
                    {
                        Object.entries(p.getCPU()).map(([key, value]) => (
                            <li key={key}>{key}: {value}</li>
                        ))
                    }
                </ul>

                <h3>OS</h3>
                <ul>
                    {
                        Object.entries(p.getOS()).map(([key, value]) => (
                            <li key={key}>{key}: {value}</li>
                        ))
                    }
                </ul>

                <h3>Device</h3>
                <ul>
                    {
                        Object.entries(p.getDevice()).map(([key, value]) => (
                            <li key={key}>{key}: {value}</li>
                        ))
                    }
                </ul>

                <h3>Engine</h3>
                <ul>
                    {
                        Object.entries(p.getEngine()).map(([key, value]) => (
                            <li key={key}>{key}: {value}</li>
                        ))
                    }
                </ul>

                <h3>UA</h3>
                <ul>
                    <li>{p.getUA()}</li>
                </ul>
            </>
        )
    }
}
